// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"68":"9ec276b0","240":"8afb6fd2","419":"a391628c","597":"a3717c41","667":"36d0229f","804":"3321b20d","927":"85952d6e","978":"e104ae6b","979":"7d54fd90"}[chunkId] + ".css";
};